module.exports = __webpack_public_path__ + "刘松-302d526b.png";